var vsprintf = require('sprintf-js').vsprintf;

function autoFormat(address) {
    if (!address) {
        return
    }

    if (address.hasOwnProperty('unit_number')) {
        return formatFromApi(address);
    }

    return format(address);
}

function format(address) {
    if (!address) {
        return null;
    }

    var s = address.unitNumber || '';

    if (s) {
        s += '/';
    }

    s += address.streetNumber;

    if (address.streetName) {
        s += ' ' + address.streetName;
    }
    if (address.streetType) {
        s += ' ' + address.streetType;
    }

    return s + ' ' + address.suburb;
}

function formatFromApi(address) {
    var parts = [];
    if (address.unit_number) {
        parts.push(vsprintf('%s/%s', [address.unit_number, address.street_number]));
    } else if (address.street_number) {
        parts.push(address.street_number);
    }
    if (address.street_name) {
        parts.push(address.street_name);
    }
    if (address.street_type) {
        parts.push(address.street_type);
    }
    if (address.suburb) {
        parts.push(address.suburb);
    }
    if (address.state) {
        parts.push(address.state);
    }
    if (address.postcode) {
        parts.push(address.postcode);
    }

    return parts.join(' ');
}

module.exports = {
    autoFormat: autoFormat,
    format: format,
    formatFromApi: formatFromApi
};



// WEBPACK FOOTER //
// ./app/util/Address.js